var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-base-application',{attrs:{"title":"定時／有給休暇付与ルール","icon":"fas fa-cogs"}},[_c('hr-settings')],1)}
var staticRenderFns = []

export { render, staticRenderFns }